<template>
  <div class="cate-menu" :style="myStyle">
    <div class="item all"
      @click="clickItem(null, -1)"
      :class="{active: selectedIndex === -1}"
    >
      全部
    </div>

    <el-tooltip
      :manual="true"
      :value="isShowTooltip(i, '.myTextOverflowRef')"
      placement="top"
      :open-delay="1000"
      v-for="(item, i) in myOptions"
      :key="i"
    >
      <div
        slot="content"
        style="max-width: 380px;"
      >{{item.name}}</div>
      <div
        class="item myTextOverflowRef"
        :class="{active: selectedIndex === i}"
        @click="clickItem(item, i)"
        @mouseover="onMOName(i)"
        @mouseout="onMOutName()"
      >
        {{item.name}}
      </div>
    </el-tooltip>

    <div class="item more"
      @click="onMore"
      v-if="options && options.length && options.length > 4"
    >
      {{isExpand ? '折叠' : '更多'}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default () {
        return [];
      },
    },
    selectedIndex: {
      type: Number,
      default: -1
    },
    myStyle: {
      type: Object,
      default () {
        return {};
      }
    },
  },
  data () {
    return {
      isExpand: false,
      hoverIndex: -1
    }
  },
  computed: {
    myOptions: {
      get () {
        return this.isExpand ? this.options : this.options.slice(0, 4);
      }
    }
  },
  methods: {
    clickItem (item, i) {
      this.$emit('clickItem', i);
    },
    onMore () {
      // this.$emit('clickMore');
      this.isExpand = !this.isExpand;
    },
    onMOName (index) {
      this.hoverIndex = index;
    },
    onMOutName () {
      this.hoverIndex = -1;
    },
    isShowTooltip (index, selector) {
      if (this.hoverIndex < 0) {
        return false;
      }
      let el = $(this.$el).find('.myTextOverflowRef')[this.hoverIndex];
      if (!el) {
        return false;
      }
      let scrollWidth = el.scrollWidth;
      let offsetWidth = el.offsetWidth;
      let isOverflow = scrollWidth > offsetWidth
      return this.hoverIndex === index && isOverflow;
    }
  }
}
</script>

<style lang="scss" scoped>
.cate-menu {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 270px;
  transition-duration: 0.3s;
}
.item {
  width: 80px;
	height: 30px;
  line-height: 30px;
	border-radius: 4px;
	border: solid 1px #d4d4e7;
  color: #474261;
  margin-right: 15px;
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 10px;

  cursor: pointer;

  &:nth-child(3n) {
    margin-right: 0;
  }
  

  &.more {
    color: #5778fb
  }

  &:hover, &.active {
    border-color: #5778fb;
  }
}

.myTextOverflowRef {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/controls/cateMenu.vue